import React from 'react'

import { i18n } from '../services/i18n'

import { PrepareDownloadBody, ReadyForDownloadBody } from '../../coreWeb/containers/Toasts/exports/bodies'
import { EXPORT_CANCELLED } from '../constants/exports'

export const getToastConfig = (handlePromiseCancel) => ({
  loadingMessage: 'Preparing download...',
  successMessage: 'Ready to download',
  errorMessage: i18n.t('entries:download_entries_export_failure_toast'),
  loadingOptions: {
    title: <PrepareDownloadBody onPromiseCancel={handlePromiseCancel} />
  },
  successOptions: {
    dismissible: true,
    autoClose: false,
    title: i18n.t('entries:download_entries_export_success_head_toast'),
    body: <ReadyForDownloadBody />
  },
  errorOptions: {
    hideOnErrorCondition: (e) => (e === EXPORT_CANCELLED || e?.message === EXPORT_CANCELLED),
    icon: 'warning'
  }
})
